import api from "./index";

export interface SlotItem {
  id: string;
  label: string;
}

export const getAllSlots = async () => {
  return api.get("/slots/getall");
};

export interface SlotCreateUpdatePayload {
  id?: string;
  startTime: string; // "03:00 PM"
  endTime: string;   // "04:00 PM"
  day?: string;      // e.g. Mon
  status: boolean;
  clinicId: string;
  date?: string;     // YYYY-MM-DD
  notes?: string;
}

export interface SlotPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc";
  whereClause: Array<{ key: string; value: string; operator: string }>;
}

export const createOrUpdateSlot = async (payload: SlotCreateUpdatePayload) => {
  return api.post("/slots/Create-Update", payload);
};

export const getSlotById = async (id: string) => {
  return api.get(`/slots/getone/${id}`);
};

export const paginateSlots = async (payload: SlotPaginationPayload) => {
  return api.post("/slots/pagination", payload);
};

export const getSlotsByMonth = async (year: number, month: number) => {
  return api.get(`/slots/by-month?year=${year}&month=${month}`);
};

export const getSlotsByDate = async (date: string) => {
  return api.get(`/slots/by-date?date=${encodeURIComponent(date)}`);
};

export interface CreateMultipleSlotsPayload {
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  startTime: string;
  endTime: string;
  clinicId: string;
  status: boolean;
  day: string[];
}

export const createMultipleSlots = async (payload: CreateMultipleSlotsPayload) => {
  return api.post("/slots/create-multiple", payload);
};

export const getSlotsByWeek = async (startDate: string, endDate: string) => {
  return api.get(`/slots/by-week?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`);
};

export const getWeeklySummary = async (startDate: string, endDate: string) => {
  return api.get(`/slots/weekly-summary?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`);
};

export const deleteSlot = async (id: string) => {
  return api.get(`/slots/delete/${id}`);
};